



























































































import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import * as types from "../store/types";

export default Vue.extend({
  name: "SidebarLayout",

  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    sidebarTitle: {
      type: String,
      default: "Get Started",
    },
    sidebarOnTop: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN,
    }),
    order(): {
      content: {
        mobile: number;
        desktop: number;
      };
      sidebar: {
        mobile: number;
        desktop: number;
      };
    } {
      return this.sidebarOnTop
        ? {
            content: {
              mobile: 2,
              desktop: 1,
            },
            sidebar: {
              mobile: 1,
              desktop: 2,
            },
          }
        : {
            content: {
              mobile: 1,
              desktop: 2,
            },
            sidebar: {
              mobile: 2,
              desktop: 1,
            },
          };
    },
  },
  methods: {
    ...mapActions({
      setShowTranslate: types.SET_SHOW_TRANSLATE,
    }),
  },
});
